import React from 'react';
import Category from '../models/Category';
import Section from '../models/Section';
import Expandable from '../components/Expandable';
import SectionsList from './SectionsList';
import Dropdown from '../components/Dropdown';
import CategoryLink from './CategoryLink';

interface MobileSubnavDropdownProps {
  categories: Category[];
  situations: Section[];
  tags: Section[];
}

export default class MobileSubnavDropdown extends React.PureComponent<MobileSubnavDropdownProps> {
  render() {
    return (
      <Dropdown
        hoverDisabled
        className="jump-to"
        heading="Jump to"
        menu={
          <div>
            <Expandable
              headerClassName="menu-item"
              title="Tags"
              menu={<SectionsList sections={this.props.tags} searchable />}
            />
            {this.props.categories.map(category => (
              <CategoryLink key={category.name} className="menu-item bold" category={category} />
            ))}
            <Expandable
              title="Situations"
              headerClassName="menu-item expandable-situations-header"
              menu={<SectionsList sections={this.props.situations} sectionsClickable={true} />}
            />
          </div>
        }
      />
    );
  }
}
